<template>
  <div id="app">
    <pay></pay>
  </div>
</template>

<script>
import pay from './components/pay.vue'
export default {
  name: 'app',
  components: {
    pay
  }
}
</script>

<style lang="less">
@import url(./styles/public.less);
</style>



// WEBPACK FOOTER //
// App.vue?bf17f486